import { DomSanitizer } from '@angular/platform-browser';
import { Pipe } from '@angular/core';

@Pipe({ name: 'safehtml' })
export class SafeHtmlPipe {
    constructor(private sanitizer: DomSanitizer) { }

    transform(data) {
        return this.sanitizer.bypassSecurityTrustHtml(data);
        // return this.sanitizer.bypassSecurityTrustStyle(data);
        // return this.sanitizer.bypassSecurityTrustXxx(data); - see docs
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/safehtml.pipe.ts